// AcctShell: passthrough داخل قوقعة AcctLayout — لم يعد يُدرج AppShell أو التبويبات.
// يعرض فقط شريط الإجراءات (إن وُجد) ثم محتوى الصفحة، حتى لا يُعاد بناء التبويبات أبداً.
export const AcctShell = ({ actions, children }) => (
  <div className="grid gap-6" data-testid="acct-shell">
    {actions ? (
      <div className="flex flex-wrap justify-end gap-3" data-testid="acct-actions">
        {actions}
      </div>
    ) : null}
    {children}
  </div>
);
